// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/planning.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { PlanningService } from "./planning_pb";

/**
 * Plan builds one route from a PlanRequest.
 *
 * @generated from rpc travplaces.v1.PlanningService.Plan
 */
export const plan = PlanningService.method.plan;

/**
 * PlanCoverage returns the ground a plan would search, as geometry, without
 * planning or looking anything up.
 *
 * @generated from rpc travplaces.v1.PlanningService.PlanCoverage
 */
export const planCoverage = PlanningService.method.planCoverage;

/**
 * PlanRecommendations ranks what the corridor offers without planning.
 *
 * @generated from rpc travplaces.v1.PlanningService.PlanRecommendations
 */
export const planRecommendations = PlanningService.method.planRecommendations;

/**
 * PlanThemes plans the same journey once per theme so they can be compared.
 *
 * @generated from rpc travplaces.v1.PlanningService.PlanThemes
 */
export const planThemes = PlanningService.method.planThemes;

/**
 * PlanDirections turns a plan that has already been made into turn-by-turn
 * directions. One router call, no optimiser, and only when somebody asks
 * for a file.
 *
 * @generated from rpc travplaces.v1.PlanningService.PlanDirections
 */
export const planDirections = PlanningService.method.planDirections;
